import * as React from "react";
import { TimeSeriesLineChartLegend } from "../Legend/implementations/TimeSeriesLineChartLegend";
import TimeSeriesLineChart, {
  TimeSeriesLineChartProps,
} from "../TimeSeriesLineChart/TimeSeriesLineChart";
import {
  TimeSeriesSharedTooltipRenderer,
  TooltipSettings,
} from "../TimeSeriesSharedTooltip/TimeSeriesSharedTooltipRenderer";
import moment from "moment/moment";
import { useElementSize } from "../../utils/useElementSize";
import { ChartSeriesItemProps } from "@progress/kendo-react-charts";
export interface MultiLineTimeSeriesChartProps
  extends TimeSeriesLineChartProps {
  legendProps?: Partial<React.ComponentProps<typeof TimeSeriesLineChartLegend>>;
  tooltipSettings?: TooltipSettings;
  xAxisTitle?: string;
  yAxisTitle?: string;
  chartSeriesItemProps?: ChartSeriesItemProps;
}

const MultiLineTimeSeriesChart = ({
  legendProps,
  items,
  valueAxisFormatter,
  tooltipSettings,
  xAxisTitle,
  yAxisTitle,
  chartSeriesItemProps,
  ...rest
}: MultiLineTimeSeriesChartProps) => {
  const [ref, { width }] = useElementSize();
  const maxDivisionsFromRef = width < 250 ? 3 : width < 480 ? 5 : 8;
  return (
    <div ref={ref} style={{ width: "100%" }}>
      <TimeSeriesLineChartLegend
        timeSeriesItems={items}
        valueFormatter={valueAxisFormatter}
        {...legendProps}
      />

      <TimeSeriesLineChart
        chartValueAxisItemProps={{
          title: {
            text: yAxisTitle,
          },
        }}
        maxDivisions={maxDivisionsFromRef}
        items={items}
        valueAxisFormatter={valueAxisFormatter}
        sharedTooltipRender={(context) =>
          TimeSeriesSharedTooltipRenderer(
            context,
            valueAxisFormatter,
            dailyDateFormatter,
            { hideTotal: true, ...tooltipSettings }
          )
        }
        zoomable={{
          mousewheel: {
            //@ts-ignore
            rate: 0.05,
          },
        }}
        {...rest}
        height={rest.chartStyle?.height as number}
        width={rest.chartStyle?.width as number}
        chartStyle={{ ...rest.chartStyle }}
        chartSeriesItemProps={chartSeriesItemProps}
      />
    </div>
  );
};
const dailyDateFormatter = (d?: string) => moment(d).format("DD MMMM YYYY");

export default MultiLineTimeSeriesChart;
